<!--
 * @Description: 物流监控/订单信息 入口
 * @Author: l_hc
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-06-17 16:27:20
 * @LastEditTime: 2019-09-26 09:04:53
 -->
<template>
  <div class="order-info">
    <div class="search-warp">
      <div class="search">
        <el-input
          v-model="orderNum"
          :maxlength="20"
          placeholder="请输入订单编号查询"
          class="input-with-select"
        >
          <el-button slot="append" class="search-btn" icon="el-icon-search" @click="query">搜索</el-button>
        </el-input>
      </div>
    </div>
    <div class="table">
      <div class="table-warp">
        <div class="table-head">
          <el-row class="center">
            <el-col :span="8">起运地/目的地</el-col>
            <el-col :span="4">订单编号</el-col>
            <el-col :span="4">货物名称</el-col>
            <el-col :span="3">货源单位</el-col>
            <el-col :span="3">承运单位</el-col>
            <el-col :span="2">操作</el-col>
          </el-row>
        </div>
        <div v-loading="loading" class="table-body">
          <div v-if="!tableData.length" class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
          <template v-else>
            <div v-for="(item, index) in tableData" :key="index" class="table-body-item">
              <el-row type="flex" align="middle" class="center table-body-item-head">
                <el-col :span="8" class="address">
                  <el-row>
                    <el-col :span="10">
                      <span class="address-label">{{ item.startPlace }}</span>
                    </el-col>
                    <el-col :span="4" style="padding: 0 10px;">
                      <img style="width: 100%;" src="../../../assets/img/arrow_half.png">
                    </el-col>
                    <el-col :span="10">
                      <span class="address-label">{{ item.stopPlace }}</span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="4">
                  <div>{{ item.orderNum }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="logo">
                    <span class="iconfont" :class="goodstypeicon(item.goodsTypeLabel)" />
                  </div>
                  <div>{{ item.goodsTypeLabel }}—{{ item.goodsName }}</div>
                </el-col>
                <el-col :span="3">
                  <div class="logo">
                    <img :src="item.goodsCompanyLogo | getImg">
                  </div>
                  <div class="name">{{ item.goodsCompany }}</div>
                </el-col>
                <el-col :span="3">
                  <div class="logo">
                    <img :src="item.transportCompanyLogo | getImg">
                  </div>
                  <div class="name">{{ item.transportCompany }}</div>
                </el-col>
                <el-col :span="2">
                  <el-button
                    class="details"
                    plain
                    size="small"
                    @click="isLogin() && active == index ? active = -1 : active = index"
                  >
                    详情
                    <i
                      :class="{'expand': active == index ? true : false}"
                      class="el-icon-d-arrow-right"
                    />
                  </el-button>
                </el-col>
              </el-row>
              <table-item v-if="active == index" :table-data="item" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findAllCmsOrder } from '@/api/monitor/orderInfo'
import mixinsFunction from '@/utils/mixinsFunction'
import TableItem from './components/TableItem'
import { mapGetters } from 'vuex'
export default {
  name: 'OrderInfo',
  components: { TableItem },
  mixins: [mixinsFunction],
  computed: {
    ...mapGetters(['authStatus', 'userInfo'])
  },
  data() {
    return {
      orderNum: '',
      // 只选择一个
      active: -1,
      tableall: false,
      tableData: [],
      loading: false
    }
  },
  created() {
    // this.getData()
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.query()
      }
    }
  },
  methods: {
    // 查询方法
    getData() {
      if (this.orderNum === '') return false
      this.loading = true
      if (this.userInfo.userType == 3 || this.userInfo.userType == 4) {
        this.$message({
          message: '货运订单不存在',
          type: 'warning'
        })
      } else {
        findAllCmsOrder({
          orderNum: this.orderNum,
          pageSize: 10,
          pageNo: 1
        }).then(res => {
          if (
            !res ||
            !res.result ||
            !res.result.rows ||
            res.result.rows.length < 1
          ) {
            this.$message({
              message: '该订单不存在!',
              type: 'error'
            })
            this.tableData = []
            return false
          }
          this.tableData = res.result.rows
        })
      }
      this.loading = false
    },
    // 货物类型icon
    goodstypeicon(goodsTypeLabel) {
      const obj = {
        成品油: 'iconyoupin',
        原油: 'iconyuanyou',
        化工品: 'iconhuagongpin'
      }
      return obj[goodsTypeLabel]
    },
    // 查询按钮
    query() {
      if (this.authStatus == '2') {
        this.getData()
      } else {
        this.$router.push({ name: 'QualificationsAuthen' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./order-info.scss";
// 详情按钮颜色
/deep/.el-button.is-plain:focus,
.el-button.is-plain:hover {
  color: $base-color;
  border-color: $base-color;
}
.details {
  font-size: 14px;
  border-color: $base-color;
  color: $base-color;
  span > i {
    transition: 1s all;
    transform: rotateZ(90deg);
    &.expand {
      transform: rotateZ(-90deg);
    }
  }
}
// 成品油图标颜色
.iconyoupin {
  color: #f2b252;
}
// 原油图片颜色
.iconyuanyou {
  color: #a3844c;
}
// 化工品图标颜色
.iconhuagongpin {
  color: #e64b51;
}
.center {
  text-align: center;
  >div{
    padding: 0px 8px;
  }
}
.logo {
  width: 34px;
  height: 34px;
  margin: 0 auto;
  border-radius: 50px;
  overflow: hidden;
  img {
    width: 100%;
    height:100%;
  }
}

.name {
  margin-top: 8px;
}
.order-info {
  font-size: 14px;
  .search-warp {
    background-color: #fff;
    width: 100%;
    margin-top: 16px;
    .search {
      width: 1200px;
      height: 82px;
      margin: 0 auto;
      padding-top: 18px;
      background: #fff;
      &-btn {
        background-color: $base-color;
        border-radius: 0px 4px 4px 0px;
        color: #fff;
        border: 1px solid $base-color;
      }
    }
  }
  .table {
    background-color: #fafafa;
    &-warp {
      width: 1200px;
      margin: 0 auto;
      padding-top: 15px;
      padding-bottom: 57px;
      .table-head {
        margin-bottom: 7px;
        .el-row {
          height: 50px;
          line-height: 50px;
          color: $base-color;
          background-color: #fff;
          border-radius: 4px;
          box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
  .table-body-item {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
    border-radius: 4px;
    margin-bottom: 9px;
    &-head {
      font-size: 14px;
      height: 82px;
      background-color: #fff;
      .iconfont {
        font-size: 25px;
      }
    }
    .address {
      .address-label{
        position: relative;
        width: 100%;
        font-size: 16px;
        // overflow: hidden;
        color: #555555;
        font-weight: bold;
        // white-space: nowrap;
        text-overflow: ellipsis;
      }
      &-box {
        display: flex;
        justify-content: center;
        align-items: baseline;
        div,
        div img {
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
